<app-store-navigation></app-store-navigation>
<div>
  <h4>Export Rota:</h4>
  <div class="d-flex mb-4">
    <div class="float-start">
      <button class="btn btn-primary-outline ms-3" (click)="openPDF()" [disabled]="!allRotasLoaded()">
        <i class="fa fa-download"></i> Download PDF
      </button>
    </div>
    <div class="float-start">
      <button class="btn btn-primary-outline ms-2" (click)="sendEmail()" [disabled]="!allRotasLoaded()">
        <i class="fa fa-envelope"></i> Send Rota PDF to email
      </button>
    </div>
  </div>

  <h4>PDF contents:</h4>
  @for (week of dataService.predictionRotaWeeks; track week) {
    <div>
      @if (week.rotaExist) {
        <app-rota-week-data
          id="rota-week-{{week.id}}"
          [weekId]="week.id"
          [showLinks]="false"
          (isLoaded)="incrementRotasLoaded($event)">
        </app-rota-week-data>
      }
    </div>
  }
</div>

